// extracted by mini-css-extract-plugin
module.exports = {"geoJSONTitle":"GeoJSONList_geoJSONTitle__1NHw2","geoJSON":"GeoJSONList_geoJSON__2sfbK"};